// Keys
export enum SessionCookieKeyNames {
  CHECKOUT_SESSION = 'subscribe_successful_checkout_session',
  SESSION_ID = 'session_id',
  CREATE_ACCOUNT_SESSION = 'create_account_successful_session',
  CANCEL_SUBSCRIPTION_SESSION = 'cancel_subscription_session',
}

// Values
interface CheckoutSessionExistingUser {
  email: string
  isExistingUser: true
  uid: string
}

interface CheckoutSessionNewUser {
  email: string
  isExistingUser: false
  password: string
  accessToken: string
  uid: string
}

export interface CreateAccountSession {
  email: string
  isExistingUser: true
  accessToken: string
  refreshToken: string
  uid: string
  password: ''
}

export interface CancelSubscriptionSession {
  hasSuccessfullyCanceledSubscription: string
}

export type CheckoutSession = CheckoutSessionExistingUser | CheckoutSessionNewUser
